import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { forkJoin } from 'rxjs';

import type { DropdownOption } from '@ui';
import type { EmployerBusinessOption } from '@shared/interfaces/opportunity.interface';
import { ActivitySubmitService } from './activity-submit.service';
import { environment } from '@environments';

export interface ActivityDataInitData {
  occupations: {
    employmentOptions: DropdownOption[];
    sectorOptions: DropdownOption[];
    sectorRaw: EmployerBusinessOption[];
  };
  provinces: { options: DropdownOption[]; preselectId: string | null };
}

export const activityDataResolver: ResolveFn<ActivityDataInitData> = () => {
  const submitService = inject(ActivitySubmitService);

  return forkJoin({
    occupations: submitService.loadOccupations(),
    provinces: submitService.loadProvinces(environment.defaultCountry)
  });
};
